import styles from "./StatementsGrid.module.css";

export type StatementCard = {
  title?: string;
  quote: string;
  role?: string;
  org?: string;
  imageSrc: string;
  imageAlt: string;
  href?: string;
  hrefLabel?: string;
};

type Props = {
  headline?: string;
  subline?: string;
  items: StatementCard[];
};

export function StatementsGrid({
  headline = "Statements",
  subline,
  items,
}: Props) {
  return (
    <section className={styles.section} aria-labelledby="statements-headline">
      <div className={styles.inner}>
        <header className={styles.header}>
          <h2 id="statements-headline" className={styles.headline}>
            {headline}
          </h2>
          {subline ? <p className={styles.subline}>{subline}</p> : null}
        </header>

        {/* ✅ untereinander */}
        <div className={styles.list} role="list">
          {items.map((it, idx) => (
            <article key={idx} className={styles.row} role="listitem">
              {/* ✅ 1/3 Bild-Card links */}
              <div className={styles.imageCard}>
                <div className={styles.imageWrap}>
                  <img
                    className={styles.image}
                    src={it.imageSrc}
                    alt={it.imageAlt}
                    loading="lazy"
                  />
                </div>
              </div>

              {/* ✅ 2/3 Text-Card rechts */}
              <div className={styles.textCard}>
                {it.title ? <h3 className={styles.title}>{it.title}</h3> : null}

                <p className={styles.quote}>{it.quote}</p>

                <div className={styles.meta}>
                  <div className={styles.roleLine}>
                    {[it.role, it.org].filter(Boolean).join(" · ")}
                  </div>
                </div>

                {it.href ? (
                  <a className={styles.link} href={it.href}>
                    {it.hrefLabel ?? "Mehr erfahren"}
                  </a>
                ) : null}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}